import { Discipline, UseCase } from "@/services/global-services/models";

export enum DataType {
    NONE,
    BOOLEAN,
    STRING,
}

export interface DataTableColumnDefinition {
    value: string;
    dataType: DataType;
    width?: number;
    metadata?: Metadata;
}

export interface DataTableConfig {
    title?: string;
    columns: DataTableColumnDefinition[];
    caption?: string;
    showGroupHeaderRows?: boolean;
    hasPropertyLevel: boolean;
    useCases?: UseCase[];
    disciplines?: Discipline[];
}

export interface DataTableData {
    rows: DataTableRow[];
    footnotes: DataTableFootnote[];
    caption: string;
}

export interface DataTableRow {
    id: string;
    cells: DataTableCell[];
    metadata?: Metadata;
}

export interface DataTableCell {
    id: string;
    value: string;
    footnotes: string[];
    focus?: boolean;
    metadata?: Metadata;
    modified?: boolean;
}

export interface DataTableFootnote {
    id: string;
    value: string;
    notetype: string;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type Metadata = Record<string, string | undefined | any[] | boolean>;
